<template>
  <v-card outlined height="100%">
    <v-card-title class="py-0">
      <v-toolbar dense flat>
        {{ bbrbbr.length }} registrierte Nutzer
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-text-field
            v-model='search'
            append-icon='search'
            label='Suchen'
            single-line
            solo
            flat
            hide-details
            clearable
            clear-icon="close"
          ></v-text-field>
        </v-toolbar-items>
        <v-spacer class="hidden-sm-and-up"></v-spacer>
      </v-toolbar>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="ma-0 pa-0">
      <v-data-table
        dense
        height="calc(100vh - 480px)"
        :headers="headers"
        :items="bbrbbr"
        :search="search"
        fixed-header
        hide-default-footer
        :items-per-page="-1"
        no-data-text="Keine Kontakte vorhanden"
      >
        <template v-slot:item="{ item, index }">
          <tr class="hidden-xs-only">
            <td>{{ index + 1 }}</td>
            <td>{{ item.nachname }}, {{ item.vorname }}</td>
            <td>{{ item.id }}</td>
            <td>{{ item.anmeldeID }}</td>
            <td>{{ item.email }}</td>
          </tr>
          <tr class="hidden-sm-and-up">
            <td>{{ index + 1 }}</td>
            <td>{{ item.nachname }}, {{ item.vorname }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      response: [],
      headers: [
        { number: '1', text: '', align: 'left', value: 'index' },
        { number: '3', text: 'Name', align: 'left', value: 'nachname' },
        { number: '4', text: 'ID', align: 'left', value: 'id' },
        { number: '5', text: 'Anmelde ID', align: 'left', value: 'anmeldeID' },
        { number: '6', text: 'Mail', align: 'left', value: 'email' }
      ]
    }
  },
  computed: {
    bbrbbr () {
      return this.$store.state.bbrbbr.bbrbbr.filter(bbr => bbr.anmeldeID)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Nutzerverwaltung.vue?0ab2e8d7